/** Strip HTML to plain text for previews, search snippets, and empty checks */
export function richTextToPlainText(html) {
  if (!html || typeof html !== 'string') return '';
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Strip tags and entities to detect empty rich text */
export function isRichTextEmpty(html) {
  return richTextToPlainText(html).length === 0;
}

/** True when content looks like HTML from the editor */
export function isHtmlContent(content) {
  return /<[a-z][\s\S]*>/i.test(String(content || ''));
}

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Plain text (legacy) → paragraphs; HTML passes through unchanged */
export function formatContentForDisplay(content) {
  if (!content) return '';
  if (isHtmlContent(content)) return content;
  return String(content)
    .split(/\n{2,}/)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) => `<p>${escapeHtml(block).replace(/\n/g, '<br />')}</p>`)
    .join('');
}
